import { render, staticRenderFns } from "./ProductPriceTable.vue?vue&type=template&id=6dcd89fe&scoped=true"
import script from "./ProductPriceTable.vue?vue&type=script&lang=js"
export * from "./ProductPriceTable.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceTable.vue?vue&type=style&index=0&id=6dcd89fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcd89fe",
  null
  
)

export default component.exports